<div class="max-h-full flex flex-col items-end gap-[var(--gap-medium)]" >
  <table class="w-full overflow-auto grid content-start" [class.has-tfoot]="$footRow() !== null" [class]="$tableStyle()" [class.zebra]="$zebra()" [style.Height]="$tableHeight()" >
    <thead [style.height]="$headHeight()"> <!-- HEAD -->
      <tr>
      @for (column of $columns(); track column; let columnIndex = $index) {
       @if (column.hide !== true) {
        <th
          [style.width]="column.width"
          [class.shrink-0]="column.width !== '100%'"
          [class.sticky-left]="$firstColumnSticky() && $index === $firstColumnIndex()">
          <span class="flex items-center">
            <p class="!font-bold" [class.uppercase]="$headUppercase()">{{ column.title }}</p>
            @if (column.sortable !== false) {
            <app-button
              icon="unfold-more-horizontal"
              [iconScale]=".82"
              [iconColor]="column.key !== $lastSortingColumnKey() ? '--black-white' : '--secondary'"
              [disabled]="$loading()"
              (click)="onSort(column)"
            />
            }
          </span>
        </th>
       }
      }
      </tr>
    </thead>

    <tbody [appSkeleton]="!$loading() ? false : $loadingSkeleton()" dirBorder="tiny"> <!-- BODY -->
    @for (row of ($itemsPerPage() < 0 ? $rows() : sortedRows); track row; let rowIndex = $index) {
      <tr [style.height]="$rowsHeight()" [class.selected]="$selectedRow() === row" >
      @for (column of $columns(); track column; let columnIndex = $index) {
        @let value = row[column.key];
        @if (column.hide !== true) {
        <td
          [style.width]="column.width"
          [class.shrink-0]="column.width !== '100%'"
          [class.sticky-left]="$firstColumnSticky() && columnIndex === $firstColumnIndex()"
          [style.paddingLeft]="column.paddingLeft | cssValue"
          (click)="$allowRowSelection() && !$loading() && onRowSelected($event, row, column, value)"
        >
        @if (column.text) { <!-- Texto -->
          @let text = column.text;
          <p
            [style.color]="(text.color && text.color(row) | cssValue)"
            [style.fontSize]="(text.fontSize && text.fontSize(row) | cssValue)"
            [style.fontWeight]="(text.fontWeight && text.fontWeight(row) | cssValue)"
            [style.-webkit-line-clamp]="text.lineClamp ?? null"
            [class.line-clamp]="text.lineClamp"
            [class.has-tooltip]="text.tooltip && text.tooltip(row)"
            [matTooltip]="(text.tooltip && text.tooltip(row)) ?? ''"
          >{{ text.value ? text.value(row) : value }}</p>
        }
        @else if (column.icon) { <!-- Ícono -->
          @let icon = column.icon;
          @if (icon.show === undefined || icon.show(row)) {
          <app-icon
            [icon]="icon.name(row)"
            [size]="(icon.size && icon.size(row))"
            [color]="(icon.color && icon.color(row))"
            [scale]="(icon.scale && icon.scale(row)) ?? 1"
            [viewBoxAdjustmentX]="(icon.viewBoxAdjustmentX && icon.viewBoxAdjustmentX(row)) ?? 0"
            [viewBoxAdjustmentY]="(icon.viewBoxAdjustmentY && icon.viewBoxAdjustmentY(row)) ?? 0"
          />
          }
        }
        @else if (column.badge) { <!-- Badge -->
          @if (column.badge.show === undefined || column.badge.show(row)) {
          <app-badge [text]="column.badge.text(row)" [type]="column.badge.type(row)" />
          }
        }
        @else if (column.buttons) { <!-- Botones -->
          @let buttons = column.buttons;
          <div class="flex gap-[var(--gap-small)]">
           @for (button of buttons; track button) {
            @if (button.show === undefined || button.show(row)) {
            <app-button
              [text]="(button.text && button.text(row)) ?? null"
              [textColor]="(button.textColor && button.textColor(row)) ?? '--black-white'"
              [textFontSize]="(button.textSize && button.textSize(row)) ?? '--font-size-small'"
              [textWeight]="(button.textWeight && button.textWeight(row)) ?? 'normal'"
              [tooltip]="(button.tooltip && button.tooltip(row)) ?? ''"
              [tooltipWhenDisabled]="(button.tooltipWhenDisabled && button.tooltipWhenDisabled(row)) ?? ''"
              [disabled]="(button.disabled && button.disabled(row)) ?? false"
              [gap]="(button.gap && button.gap(row)) ?? '--gap-tiny'"
              [icon]="(button.icon && button.icon(row)) ?? null"
              [iconColor]="(button.iconColor && button.iconColor(row)) ?? '--primary-secondary'"
              [iconSize]="(button.iconSize && button.iconSize(row)) ?? ''"
              [iconScale]="(button.iconScale && button.iconScale(row)) ?? 1"
              (click)="button.action(row)"
            />
            }
           }
          </div>
        }
        @else if (column.switch) {
          @let switch = column.switch;
          @if (switch.show === undefined || switch.show(row)) {
          <app-switch
            [value]="switch.value ? switch.value(row) : false"
            [labelLeft]="(switch.labelLeft && switch.labelLeft(row)) ?? null"
            [labelRight]="(switch.labelRight && switch.labelRight(row)) ?? null"
            [labelFontSize]="(switch.labelFontSize && switch.labelFontSize(row)) ?? '--font-size-small'"
            [scale]="(switch.scale && switch.scale(row)) ?? 1"
            (valueChange)="switch.action(row)"
          />
          }
        }
        @else {
          <p>{{ value }}</p>
        }
        </td>
        }
      }
      </tr>
    }
    </tbody>

    @let row = $footRow();
    @if (row !== null) {
    <tfoot [style.height]="$footHeight()"> <!-- FOOT -->
      <tr>
      @for (column of $columns(); track column; let columnIndex = $index) {
       @if (column.hide !== true) {
        @let value = row[column.key];
        <td
          [style.width]="column.width"
          [class.shrink-0]="column.width !== '100%'"
          [class.sticky-left]="$firstColumnSticky() && columnIndex === $firstColumnIndex()"
          [style.paddingLeft]="column.paddingLeft | cssValue"
        >
        @if (column.text) { <!-- Texto -->
          @let text = column.text;
          <p
            class="!font-bold" [class.uppercase]="$footUppercase()"
            [style.color]="(text.color && text.color(row) | cssValue)"
            [style.fontSize]="(text.fontSize && text.fontSize(row) | cssValue)"
            [style.fontWeight]="(text.fontWeight && text.fontWeight(row) | cssValue)"
          >{{ text.value ? text.value(row) : value }}</p>
        }
        @else if (column.icon) { <!-- Ícono -->
          @let icon = column.icon;
          @if (icon.show === undefined || icon.show(row)) {
          <app-icon
            [icon]="icon.name(row)"
            [size]="(icon.size && icon.size(row))"
            [color]="(icon.color && icon.color(row))"
            [scale]="(icon.scale && icon.scale(row)) ?? 1"
            [viewBoxAdjustmentX]="(icon.viewBoxAdjustmentX && icon.viewBoxAdjustmentX(row)) ?? 0"
            [viewBoxAdjustmentY]="(icon.viewBoxAdjustmentY && icon.viewBoxAdjustmentY(row)) ?? 0"
          />
          }
        }
        @else if (column.badge) { <!-- Badge -->
          @if (column.badge.show === undefined || column.badge.show(row)) {
          <app-badge [text]="column.badge.text(row)" [type]="column.badge.type(row)" />
          }
        }
        @else if (column.buttons) { <!-- Botones -->
          @let buttons = column.buttons;
          <div class="flex gap-[var(--gap-small)]">
           @for (button of buttons; track button) {
            @if (button.show === undefined || button.show(row)) {
            <app-button
              [text]="(button.text && button.text(row)) ?? null"
              [textColor]="(button.textColor && button.textColor(row)) ?? '--black-white'"
              [textFontSize]="(button.textSize && button.textSize(row)) ?? '--font-size-small'"
              [textWeight]="(button.textWeight && button.textWeight(row)) ?? 'normal'"
              [tooltip]="(button.tooltip && button.tooltip(row)) ?? ''"
              [tooltipWhenDisabled]="(button.tooltipWhenDisabled && button.tooltipWhenDisabled(row)) ?? ''"
              [disabled]="(button.disabled && button.disabled(row)) ?? false"
              [gap]="(button.gap && button.gap(row)) ?? '--gap-tiny'"
              [icon]="(button.icon && button.icon(row)) ?? null"
              [iconColor]="(button.iconColor && button.iconColor(row)) ?? '--primary-secondary'"
              [iconSize]="(button.iconSize && button.iconSize(row)) ?? ''"
              [iconScale]="(button.iconScale && button.iconScale(row)) ?? 1"
              (click)="button.action(row)"
            />
            }
           }
          </div>
        }
        @else if (column.switch) {
          @let switch = column.switch;
          @if (switch.show === undefined || switch.show(row)) {
          <app-switch
            [value]="switch.value ? switch.value(row) : false"
            [labelLeft]="(switch.labelLeft && switch.labelLeft(row)) ?? null"
            [labelRight]="(switch.labelRight && switch.labelRight(row)) ?? null"
            [labelFontSize]="(switch.labelFontSize && switch.labelFontSize(row)) ?? '--font-size-small'"
            [scale]="(switch.scale && switch.scale(row)) ?? 1"
            (valueChange)="switch.action(row)"
          />
          }
        }
        @else {
          <p class="!font-bold" [class.uppercase]="$footUppercase()">{{ value }}</p>
        }
        </td>
      }
     }
      </tr>
    </tfoot>
    }
  </table>

  @if ($itemsPerPage() >= 0) {
  <app-pagination [items]="$rows()" [itemsPerPage]="$itemsPerPage()" [loading]="$loading()" (pageChange)="onPagination($event)" />
  }
</div>
